module.exports = __webpack_public_path__ + "img/type_curtain.e8132912.jpg";